import { render } from "./IncludedItemCharger.vue?vue&type=template&id=d4e048c8"
import script from "./IncludedItemCharger.vue?vue&type=script&lang=js"
export * from "./IncludedItemCharger.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__